import React from "react";
import { Parallax } from "react-parallax";
import WhatsAppButton from "./WhatsAppButton";

function GetTheApp() {
  return (
    <section id="download" className="hero-wrap">
      <div className="hero-mask opacity-9 bg-primary" />

      <Parallax
        bgImage="images/intro-bg-2.jpg"
        bgImageAlt="Intro"
        strength={200}
      >
        <div className="hero-content section">
          <div className="container">
            <div className="justify-content-center text-center">
              <h2 className="text-9 fw-600 text-white text-center mb-3">
                Vamos conversar?
              </h2>
              <hr className="heading-separator-line bg-white opacity-10 mx-auto" />
              <p className="lead text-center text-white mb-4">
                Entre em contato e vamos te explicar melhor nosso plano de negócio.
              </p>
              <WhatsAppButton />
            </div>
          </div>
        </div>
      </Parallax>
    </section>
  );
}

export default GetTheApp;
